import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { NgxDatatableModule } from '@swimlane/ngx-datatable';
import { FlexLayoutModule } from '@angular/flex-layout';
import { BrowserModule } from '@angular/platform-browser';

import { RouterModule } from '@angular/router';
import { ChartistModule } from 'ng-chartist';
import { ChartsModule } from 'ng2-charts';
import { NgApexchartsModule } from 'ng-apexcharts';
import { MeasurementDetailComponent } from './measurement-detail.component';
import { MeasurementDetailRoutingModule } from './measurement-detail-routing.module';
import { MatSelectModule } from '@angular/material/select';
import { DemoMaterialModule } from 'src/app/demo-material-module';
import { AddBaselineComponent } from '../baseline/add-baseline.component';

@NgModule({
  declarations: [MeasurementDetailComponent, AddBaselineComponent],
  imports: [
    CommonModule,
    MeasurementDetailRoutingModule,
    DemoMaterialModule,
    FormsModule,
    ReactiveFormsModule,
    DragDropModule,
    NgxDatatableModule,
    FlexLayoutModule,
    RouterModule,
    ChartistModule,
    NgApexchartsModule,
    ChartsModule,
    MatSelectModule,
  ],
})
export class MeasurementDetailModule {}
